<a class="digital-course-preview-card" [routerLink]="[baseUrl, course?.courseSlug]">
    <div ngImagePixel #LargeImageHolder="imagePixel" class="thumbail-img">
        <img class="card-image-top" [alt]="course.title" src="{{
            getDefaultImage(course?.medias)
          }}?{{LargeImageHolder.getImagePixel()}}&fit=crop" alt="Card image cap" />
    </div>
    <div class="digital-course-preview-card-body">
        <div class="course-title-section py-2">
            <h5 class="course-title m-0 text-truncate">{{course?.title}}</h5>
        </div>
        <div class="course-provider-section pb-2 d-flex align-items-center">
            <img class="arranger-logo mr-2" [src]="arrangerLogo" [alt]="course?.arranger || 'Redningsselskapet' "> <span> {{ course?.arranger || 'Redningsselskapet'}}</span>
        </div>
        <div class="course-price-section pb-2">
            <ng-container *ngIf="courseIsFree(course) === false; else freeCourse">
                <div [ngStyle]="{'height': course.price.isPriceHidden ? '40px': 'auto' }"  class="price-template">
                    <div *ngIf="!course.price.isPriceHidden" class="d-flex align-content-center alignt-items-center">
                        <div *ngIf="course.price.memberPrice > 0" class="member-price-section pr-2">
                            <div class="section-title">{{'shared.rs_member' | transloco}}</div>
                            <div class="member-price section-content">
                                {{ course.price.memberPrice }}
                                <sup class="curreny-name">{{ course?.price?.currency }}</sup>
                            </div>
                        </div>
                        <div class="non-member-price-section">
                            <div class="section-title">{{'shared.rs_non_member' | transloco}}</div>
                            <div class="non-member-price section-content">
                                {{ course.price.pricePerPerson }}
                                <sup class="curreny-name">{{ course?.price?.currency }}</sup>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="course-description-section pb-3">
            <div class="section-title">{{translationScope+'.description' | transloco}}</div>
            <div class="section-content course-description" [innerHTML]="course?.description | stripHtmlCode"></div>
        </div>
    </div>
</a>
<ng-template #freeCourse>
    <div class="free-course price-template section-content">
      {{'shared.free' | transloco}}
    </div>
</ng-template>
